import { render, staticRenderFns } from "./VoipGroup.vue?vue&type=template&id=abaa8490&scoped=true"
import script from "./VoipGroup.vue?vue&type=script&lang=js"
export * from "./VoipGroup.vue?vue&type=script&lang=js"
import style0 from "./VoipGroup.vue?vue&type=style&index=0&id=abaa8490&prod&scoped=true&lang=css"
import style1 from "./VoipGroup.vue?vue&type=style&index=1&id=abaa8490&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abaa8490",
  null
  
)

export default component.exports